import { t } from "i18next";

/**
 * Crash screen for the observability error boundary (`ObservabilityProvider`).
 *
 * Rendered ONLY in production (the boundary is prod-gated in `src/index.js`) when a render
 * error in `<App/>` is caught by `Sentry.ErrorBoundary`. Sentry passes `resetError`, which
 * re-mounts `<App/>` in place — a soft retry that keeps the conversation.
 *
 * Copy is localized via the global i18next singleton (reusing `flowErrorMessage` / `retry`);
 * the panel uses the app's `hayley-` Tailwind utilities so it matches the chat card and fills
 * whatever size the widget iframe currently is. Tailwind preflight is off, so the button
 * carries its own reset styles.
 */
export default function ObservabilityFallback({ resetError }) {
  return (
    <div className="hayley-flex hayley-h-full hayley-min-h-[140px] hayley-w-full hayley-flex-col hayley-items-center hayley-justify-center hayley-gap-4 hayley-bg-white hayley-p-6 hayley-text-center hayley-font-opensans">
      <p className="hayley-m-0 hayley-max-w-xs hayley-text-base hayley-text-secondary">{t("flowErrorMessage")}</p>
      <button
        type="button"
        onClick={resetError}
        className="hayley-cursor-pointer hayley-rounded-full hayley-border-none hayley-bg-primary hayley-px-6 hayley-py-2 hayley-text-sm hayley-font-semibold hayley-text-white"
      >
        {t("retry")}
      </button>
    </div>
  );
}
